import React from 'react';

import * as S from './styles';

import YoutubeVideo from '../../../../../../../common/YoutubeVideo';
import AudioPlayer from '../../../../../../../common/AudioPlayer';
import { ISubjectContentData } from '../../../..';
import { AcademicProjects } from './components';
import { IClassInfo } from '../../../../../../../../pages/newStudent/MyCoursesNewStudent/components/Subjects';
import { useTheme } from 'styled-components';
import { handleMinWidth } from '../../../../../../../../util/newStudent/windowWidthSize';
import { isAcademicProjectKind } from '../../../../../../../../util/newStudent/academicProject';
import ButtonSimple from '../../../../../../Buttons/ButtonSimple';

interface Props {
  data?: ISubjectContentData;
  classInfo: IClassInfo;
}

const contendNotFound = () => {
  return (
    <S.Div>
      <S.H5>
        Conteúdo não encontrado.
        <br /> Favor entrar em contato com o NAE
      </S.H5>
    </S.Div>
  );
};

export default function LessonContent({ data, classInfo }: Props) {
  const theme = useTheme();

  const showsMaterialTitle =
    Boolean(data?.title) &&
    (data?.type === 'video' ||
      data?.type === 'archive' ||
      data?.type === 'audiobook');

  return (
    <S.Container>
      <S.Content>
        {showsMaterialTitle && <S.MaterialTitle>{data?.title}</S.MaterialTitle>}
        {data?.type === 'video' &&
          (data.url ? (
            <S.VideoDiv className="video_content">
              <YoutubeVideo key={data?.url} url={data?.url} />
            </S.VideoDiv>
          ) : (
            contendNotFound()
          ))}
        {data?.type === 'archive' &&
          (data.url ? (
            handleMinWidth(theme.size?.medium) ? (
              <>
                <S.PdfDiv className="archive_content">
                  <iframe
                    src={data.url}
                    title="Visualizador de PDF"
                    width="100%"
                    height="800"
                    style={{ border: 'none' }}
                  />
                </S.PdfDiv>
              </>
            ) : (
              <ButtonSimple
                color="primary"
                heightSize="small"
                widthSize="large"
                onClick={() =>
                  window.open(data.url, '_blank', 'noopener,noreferrer')
                }
              >
                Acessar Apostila
              </ButtonSimple>
            )
          ) : (
            contendNotFound()
          ))}
        {data?.type === 'audiobook' &&
          (data.url ? (
            <S.AudioDiv className="audiobook_content">
              <AudioPlayer key={data.url} url={data.url} />
            </S.AudioDiv>
          ) : (
            contendNotFound()
          ))}
        {data?.type === 'customized' &&
          (data.customized ? (
            <div
              dangerouslySetInnerHTML={{
                __html: data.customized!,
              }}
            ></div>
          ) : (
            contendNotFound()
          ))}
        {data &&
          isAcademicProjectKind(data.type) &&
          data.type !== 'tcc' &&
          (data.title ? (
            <AcademicProjects
              key={`${data.type}-${data.contentId}-${data.resourceId ?? 0}`}
              projectKind={data.type}
              info={data}
              classInfo={classInfo}
            />
          ) : (
            contendNotFound()
          ))}
        {data && isAcademicProjectKind(data.type) && data.type === 'tcc' &&
          (data.title ? (
            <AcademicProjects
              key={`tcc-${data.contentId}-${data.resourceId ?? 0}`}
              projectKind="tcc"
              info={data}
              classInfo={classInfo}
            />
          ) : (
            contendNotFound()
          ))}
      </S.Content>
    </S.Container>
  );
}
